module.exports = __webpack_public_path__ + "img/class.f575d17b.png";